












import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import CandidatePortalLogo from '@/components/CandidatePortalLogo.vue';

@Component({
  components: { CandidatePortalLogo },
})
export default class Header extends Vue {
  @Prop({ default: false }) showImage;
  @Prop({ default: '' }) formName;
  @Prop({ default: true }) showTitle;

  get formTitle(): string {
    return this.formName != '' ? this.formName : this.getCustomWelcomeTitle;
  }

  get getCustomWelcomeTitle() {
    const customLoginTitle = vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_WELCOME_SCREEN_TITLE',
    );
    if (customLoginTitle) return customLoginTitle;
    return this.$t('login.welcome_text.emailentry', {
      companyName: this.companyName,
    });
  }

  get companyName(): String {
    return (
      vxm.configs.getGlobalConfigValue(
        'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
      ) || vxm.configs.getGlobalConfigValue('COMPANY_NAME')
    );
  }
}
